import React from "react";
import ReactDOM from "react-dom";
import { Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { isMobile } from "react-device-detect";
import { ThemeProvider } from "styled-components";
import Zendesk, { ZendeskAPI } from "react-zendesk";

import { config } from "_config";
import { history } from "_helpers";
import store from "_store";

import FontStyles from "assets/fonts";

import Membership from "layouts/Membership";
import Login from "layouts/Login";
import SetPassword from "layouts/SetPassword";
// import ResetPassword from "layouts/ResetPassword";
import ForgotPassword from "layouts/ForgotPassword";

import CustomRouter from "routes/CustomRouter";
import PrivateRoute from "routes/PrivateRoute";
import PublicRoute from "routes/PublicRoute";

import "bootstrap/dist/css/bootstrap.min.css";

const ZENDESK_KEY = "ab079416-4cd7-454c-8103-222a618ef066";

const setting = {
  color: {
    theme: "#000",
  },
  launcher: {
    chatLabel: {
      "en-US": "Need Help",
    },
  },
  contactForm: {
    fields: [{ id: "description", prefill: { "*": "My pre-filled description" } }],
  },
};

ReactDOM.render(
  <Provider store={store}>
    <FontStyles />
    <Zendesk defer zendeskKey={ZENDESK_KEY} {...setting} onLoaded={() => ZendeskAPI("webWidget", "hide")} />
    <CustomRouter basename={config.publicUrl} history={history}>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/set-password"
          element={
            <PublicRoute>
              <SetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <SetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="*"
          element={
            <PrivateRoute>
              <ThemeProvider theme={{ isMobile: isMobile, mobile: isMobile }}>
                <Membership />
              </ThemeProvider>
            </PrivateRoute>
          }
        />
      </Routes>
    </CustomRouter>
  </Provider>,
  document.getElementById("root")
);
